// extracted by mini-css-extract-plugin
export var leadForm__form = "lead-form-module--lead-form__form--03ac4";
export var leadForm__form__content = "lead-form-module--lead-form__form__content--8b169";
export var mt0 = "lead-form-module--mt-0--91a73";
export var mt1 = "lead-form-module--mt-1--c37f6";
export var mt2 = "lead-form-module--mt-2--590ff";
export var mt3 = "lead-form-module--mt-3--6eb25";
export var mt4 = "lead-form-module--mt-4--759dd";
export var mt5 = "lead-form-module--mt-5--c206c";
export var mt6 = "lead-form-module--mt-6--cec37";